module.exports = __webpack_public_path__ + "static/img/testimonial-3.43e84e73.jpg";